// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AiSuggestion_Kgv2NodeResolvedFragment, CommonAiSuggestion_WithKgv2Fragment } from '../../aiSuggestions/graphql/aiSuggestions.fragments.generated';
import { CommonAiSuggestionEvidenceFragment, ReferenceAiOnboardingSuggestionFragment } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import { gql } from '@apollo/client';
import { AiSuggestion_Kgv2NodeResolvedFragmentDoc, CommonAiSuggestion_WithKgv2FragmentDoc } from '../../aiSuggestions/graphql/aiSuggestions.fragments.generated';
import { CommonAiSuggestionEvidenceFragmentDoc, ReferenceAiOnboardingSuggestionFragmentDoc } from '../../aiSuggestions/graphql/aiSuggestions.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DpSuggestionKgRootFragment = { __typename?: 'KGRoot', id: string, kind: Types.KgRootKind };

export type AiSuggestion_DispositiveProvisionFragment = (
  { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, dpDeathEvent?: Types.AiSuggestionDispositiveProvisionDeathEvent | null, dpFirstDeathGrantorClientProfile?: { __typename?: 'ClientProfile', id: string } | null, dpRecipient?: (
    { __typename?: 'DispositiveProvisionRecipientSuggestion' }
    & DpRecipientSuggestionFragment
  ) | null, dpRecipientKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: (
        { __typename?: 'KGV2Node' }
        & AiSuggestion_Kgv2NodeResolvedFragment
      ) | null } | null> | null }, evidence?: Array<(
    { __typename?: 'AISuggestionEvidence' }
    & CommonAiSuggestionEvidenceFragment
  )> | null, entity?: { __typename?: 'Entity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, entityDocumentRelationships: { __typename?: 'EntityDocumentRelationshipConnection', edges?: Array<{ __typename?: 'EntityDocumentRelationshipEdge', node?: { __typename?: 'EntityDocumentRelationship', id: string, relationshipType: Types.EntityDocumentRelationshipRelationshipType, document: { __typename?: 'Document', id: string, type: Types.DocumentType } } | null } | null> | null } } | null, referenceAiOnboardingSuggestion?: (
    { __typename?: 'AISuggestion' }
    & ReferenceAiOnboardingSuggestionFragment
  ) | null }
  & CommonAiSuggestion_WithKgv2Fragment
);

export type DpRecipientSuggestionFragment = { __typename?: 'DispositiveProvisionRecipientSuggestion', dispositionKind?: Types.DispositiveProvisionDispositionKind | null, dispositionOrder?: number | null, distributionAmount?: string | null, distributionPercentage?: string | null, dispositionFormulaicPercentage?: string | null, dispositionLimit?: string | null, growByInflation?: boolean | null, notes?: string | null, recipientEntityName?: string | null, recipientID?: string | null, recipientKind?: Types.DispositiveProvisionRecipientKind | null, recipientOrganizationName?: string | null, recipientTransferTaxKind?: Types.DispositiveProvisionTransferTaxKind | null, distributionDeathEvent?: string | null, recipientNameParts?: { __typename?: 'PersonNameParts', firstName: string, lastName: string, middleName: string, suffix: string } | null };

export type FetchDispositiveProvisionSuggestionsQueryVariables = Types.Exact<{
  targetId: Types.Scalars['ID']['input'];
  isEntity: Types.Scalars['Boolean']['input'];
  isTestamentaryEntity: Types.Scalars['Boolean']['input'];
}>;


export type FetchDispositiveProvisionSuggestionsQuery = { __typename?: 'Query', entityDPSuggestions?: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & AiSuggestion_DispositiveProvisionFragment
      ) | null } | null> | null }, entityDPSuggestionKGRoot1?: { __typename?: 'KGRootConnection', edges?: Array<{ __typename?: 'KGRootEdge', node?: (
        { __typename?: 'KGRoot' }
        & DpSuggestionKgRootFragment
      ) | null } | null> | null }, entityDPSuggestionKGRoot2?: { __typename?: 'KGRootConnection', edges?: Array<{ __typename?: 'KGRootEdge', node?: (
        { __typename?: 'KGRoot' }
        & DpSuggestionKgRootFragment
      ) | null } | null> | null }, testamentaryEntityDPSuggestions?: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & AiSuggestion_DispositiveProvisionFragment
      ) | null } | null> | null }, testamentaryEntityDPSuggestionKGRoot?: { __typename?: 'KGRootConnection', edges?: Array<{ __typename?: 'KGRootEdge', node?: (
        { __typename?: 'KGRoot' }
        & DpSuggestionKgRootFragment
      ) | null } | null> | null } };

export type UpdateKgRootMutationVariables = Types.Exact<{
  updateKGRootInput: Types.AugmentedUpdateKgRootInput;
}>;


export type UpdateKgRootMutation = { __typename?: 'Mutation', updateKgRoot: { __typename?: 'KGRoot', id: string, status: Types.KgRootStatus } };

export type DismissAidpSuggestionsMutationVariables = Types.Exact<{
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
  updateKgRootInputs: Array<Types.AugmentedUpdateKgRootInput> | Types.AugmentedUpdateKgRootInput;
}>;


export type DismissAidpSuggestionsMutation = { __typename?: 'Mutation', acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }>, updateKGRoots: Array<{ __typename?: 'KGRoot', id: string, entity?: { __typename?: 'Entity', id: string } | null }> };

export const Operations = {
  Query: {
    FetchDispositiveProvisionSuggestions: 'FetchDispositiveProvisionSuggestions' as const
  },
  Mutation: {
    UpdateKGRoot: 'UpdateKGRoot' as const,
    DismissAIDPSuggestions: 'DismissAIDPSuggestions' as const
  },
  Fragment: {
    DPSuggestionKGRoot: 'DPSuggestionKGRoot' as const,
    AISuggestion_DispositiveProvision: 'AISuggestion_DispositiveProvision' as const,
    DPRecipientSuggestion: 'DPRecipientSuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DpSuggestionKgRootFragmentDoc = gql`
    fragment DPSuggestionKGRoot on KGRoot {
  id
  kind
}
    `;
export const DpRecipientSuggestionFragmentDoc = gql`
    fragment DPRecipientSuggestion on DispositiveProvisionRecipientSuggestion {
  dispositionKind
  dispositionOrder
  distributionAmount
  distributionPercentage
  dispositionFormulaicPercentage
  dispositionLimit
  growByInflation
  notes
  recipientEntityName
  recipientID
  recipientKind
  recipientNameParts {
    firstName
    lastName
    middleName
    suffix
  }
  recipientOrganizationName
  recipientTransferTaxKind
  distributionDeathEvent
}
    `;
export const AiSuggestion_DispositiveProvisionFragmentDoc = gql`
    fragment AISuggestion_DispositiveProvision on AISuggestion {
  id
  kind
  acceptanceStatus
  dpDeathEvent
  dpFirstDeathGrantorClientProfile {
    id
  }
  dpRecipient {
    ...DPRecipientSuggestion
  }
  dpRecipientKgV2Nodes(first: 1) {
    edges {
      node {
        ...AISuggestion_KGV2NodeResolved
      }
    }
  }
  evidence {
    ...CommonAISuggestionEvidence
  }
  entity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  testamentaryEntity {
    id
    entityDocumentRelationships {
      edges {
        node {
          id
          relationshipType
          document {
            id
            type
          }
        }
      }
    }
  }
  referenceAiOnboardingSuggestion {
    ...ReferenceAIOnboardingSuggestion
  }
  ...CommonAISuggestion_WithKGV2
}
    ${DpRecipientSuggestionFragmentDoc}
${AiSuggestion_Kgv2NodeResolvedFragmentDoc}
${CommonAiSuggestionEvidenceFragmentDoc}
${ReferenceAiOnboardingSuggestionFragmentDoc}
${CommonAiSuggestion_WithKgv2FragmentDoc}`;
export const FetchDispositiveProvisionSuggestionsDocument = gql`
    query FetchDispositiveProvisionSuggestions($targetId: ID!, $isEntity: Boolean!, $isTestamentaryEntity: Boolean!) {
  entityDPSuggestions: aiSuggestions(
    where: {hasEntityWith: {id: $targetId}, kindIn: [DP_RECIPIENT_GRANTOR_1_DIES_FIRST, DP_RECIPIENT_GRANTOR_2_DIES_FIRST]}
  ) @include(if: $isEntity) {
    edges {
      node {
        ...AISuggestion_DispositiveProvision
      }
    }
  }
  entityDPSuggestionKGRoot1: kgRoots(
    where: {hasEntityWith: {id: $targetId}, kind: ENTITY_DISPOSITIVE_PROVISIONS_GRANTOR_1_DIES_FIRST}
    orderBy: {field: created_at, direction: DESC}
    first: 1
  ) @include(if: $isEntity) {
    edges {
      node {
        ...DPSuggestionKGRoot
      }
    }
  }
  entityDPSuggestionKGRoot2: kgRoots(
    where: {hasEntityWith: {id: $targetId}, kind: ENTITY_DISPOSITIVE_PROVISIONS_GRANTOR_2_DIES_FIRST}
    orderBy: {field: created_at, direction: DESC}
    first: 1
  ) @include(if: $isEntity) {
    edges {
      node {
        ...DPSuggestionKGRoot
      }
    }
  }
  testamentaryEntityDPSuggestions: aiSuggestions(
    where: {hasTestamentaryEntityWith: {id: $targetId}, kindIn: [TE_DP_RECIPIENT_GRANTOR_1_DIES_FIRST, TE_DP_RECIPIENT_GRANTOR_2_DIES_FIRST]}
  ) @include(if: $isTestamentaryEntity) {
    edges {
      node {
        ...AISuggestion_DispositiveProvision
      }
    }
  }
  testamentaryEntityDPSuggestionKGRoot: kgRoots(
    where: {hasTestamentaryEntityWith: {id: $targetId}, kind: TESTAMENTARY_ENTITY_DISPOSITIVE_PROVISIONS}
    orderBy: {field: created_at, direction: DESC}
    first: 1
  ) @include(if: $isEntity) {
    edges {
      node {
        ...DPSuggestionKGRoot
      }
    }
  }
}
    ${AiSuggestion_DispositiveProvisionFragmentDoc}
${DpSuggestionKgRootFragmentDoc}`;

/**
 * __useFetchDispositiveProvisionSuggestionsQuery__
 *
 * To run a query within a React component, call `useFetchDispositiveProvisionSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDispositiveProvisionSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDispositiveProvisionSuggestionsQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *      isEntity: // value for 'isEntity'
 *      isTestamentaryEntity: // value for 'isTestamentaryEntity'
 *   },
 * });
 */
export function useFetchDispositiveProvisionSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>(FetchDispositiveProvisionSuggestionsDocument, withFetchPolicyContext(options));
      }
export function useFetchDispositiveProvisionSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>(FetchDispositiveProvisionSuggestionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useFetchDispositiveProvisionSuggestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>(FetchDispositiveProvisionSuggestionsDocument, withFetchPolicyContext(options));
        }
export type FetchDispositiveProvisionSuggestionsQueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsQuery>;
export type FetchDispositiveProvisionSuggestionsLazyQueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsLazyQuery>;
export type FetchDispositiveProvisionSuggestionsSuspenseQueryHookResult = ReturnType<typeof useFetchDispositiveProvisionSuggestionsSuspenseQuery>;
export type FetchDispositiveProvisionSuggestionsQueryResult = Apollo.QueryResult<FetchDispositiveProvisionSuggestionsQuery, FetchDispositiveProvisionSuggestionsQueryVariables>;
export const UpdateKgRootDocument = gql`
    mutation UpdateKGRoot($updateKGRootInput: AugmentedUpdateKGRootInput!) {
  updateKgRoot(input: $updateKGRootInput) {
    id
    status
  }
}
    `;
export type UpdateKgRootMutationFn = Apollo.MutationFunction<UpdateKgRootMutation, UpdateKgRootMutationVariables>;

/**
 * __useUpdateKgRootMutation__
 *
 * To run a mutation, you first call `useUpdateKgRootMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKgRootMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKgRootMutation, { data, loading, error }] = useUpdateKgRootMutation({
 *   variables: {
 *      updateKGRootInput: // value for 'updateKGRootInput'
 *   },
 * });
 */
export function useUpdateKgRootMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKgRootMutation, UpdateKgRootMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKgRootMutation, UpdateKgRootMutationVariables>(UpdateKgRootDocument, options);
      }
export type UpdateKgRootMutationHookResult = ReturnType<typeof useUpdateKgRootMutation>;
export type UpdateKgRootMutationResult = Apollo.MutationResult<UpdateKgRootMutation>;
export type UpdateKgRootMutationOptions = Apollo.BaseMutationOptions<UpdateKgRootMutation, UpdateKgRootMutationVariables>;
export const DismissAidpSuggestionsDocument = gql`
    mutation DismissAIDPSuggestions($acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!, $updateKgRootInputs: [AugmentedUpdateKGRootInput!]!) {
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
  updateKGRoots(inputs: $updateKgRootInputs) {
    id
    entity {
      id
    }
  }
}
    `;
export type DismissAidpSuggestionsMutationFn = Apollo.MutationFunction<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>;

/**
 * __useDismissAidpSuggestionsMutation__
 *
 * To run a mutation, you first call `useDismissAidpSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAidpSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAidpSuggestionsMutation, { data, loading, error }] = useDismissAidpSuggestionsMutation({
 *   variables: {
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *      updateKgRootInputs: // value for 'updateKgRootInputs'
 *   },
 * });
 */
export function useDismissAidpSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>(DismissAidpSuggestionsDocument, options);
      }
export type DismissAidpSuggestionsMutationHookResult = ReturnType<typeof useDismissAidpSuggestionsMutation>;
export type DismissAidpSuggestionsMutationResult = Apollo.MutationResult<DismissAidpSuggestionsMutation>;
export type DismissAidpSuggestionsMutationOptions = Apollo.BaseMutationOptions<DismissAidpSuggestionsMutation, DismissAidpSuggestionsMutationVariables>;